document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("[data-header-root]");
    if (!header) return;

    const menu = header.querySelector("[data-mobile-menu]");
    const openBtn = header.querySelector("[data-open-menu]");
    const closeBtn = header.querySelector("[data-close-menu]");
    const submenuHeads = header.querySelectorAll("[data-submenu-head]");
    const menuItems = header.querySelectorAll("[data-menu-item]");

    const isMobile = () => window.innerWidth <= 991;

    function syncBurgerButtons() {
        if (!menu || !openBtn || !closeBtn) return;
        const opened = menu.classList.contains("is-open");
        openBtn.hidden = opened;
        closeBtn.hidden = !opened;
    }

    function closeAllSubmenus(exceptItem = null) {
        menuItems.forEach((item) => {
            if (exceptItem && item === exceptItem) return;
            item.classList.remove("is-open");

            const head = item.querySelector("[data-submenu-head]");
            if (head) head.setAttribute("aria-expanded", "false");
        });
    }

    function openMobileMenu() {
        if (!menu) return;
        menu.classList.add("is-open");
        document.body.classList.add("menu-open");
        syncBurgerButtons();
    }

    function closeMobileMenu() {
        if (!menu) return;
        menu.classList.remove("is-open");
        document.body.classList.remove("menu-open");
        closeAllSubmenus();
        syncBurgerButtons();
    }

    openBtn?.addEventListener("click", openMobileMenu);
    closeBtn?.addEventListener("click", closeMobileMenu);

    submenuHeads.forEach((head) => {
        head.addEventListener("click", (event) => {
            if (event.target.closest("a")) {
                event.preventDefault();
            }

            const item = head.closest("[data-menu-item]");
            if (!item) return;

            const willOpen = !item.classList.contains("is-open");

            closeAllSubmenus(item);
            item.classList.toggle("is-open", willOpen);
            head.setAttribute("aria-expanded", String(willOpen));
        });

        head.addEventListener("keydown", (event) => {
            if (event.key !== "Enter" && event.key !== " ") return;

            event.preventDefault();

            const item = head.closest("[data-menu-item]");
            if (!item) return;

            const willOpen = !item.classList.contains("is-open");

            closeAllSubmenus(item);
            item.classList.toggle("is-open", willOpen);
            head.setAttribute("aria-expanded", String(willOpen));
        });
    });

    document.addEventListener("click", (event) => {
        if (!header.contains(event.target)) {
            closeAllSubmenus();

            if (isMobile()) {
                closeMobileMenu();
            }
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeAllSubmenus();

            if (isMobile()) {
                closeMobileMenu();
            }
        }
    });

    window.addEventListener("resize", () => {
        if (!menu) return;

        if (!isMobile()) {
            menu.classList.remove("is-open");
            document.body.classList.remove("menu-open");
        }

        closeAllSubmenus();
        syncBurgerButtons();
    });

    syncBurgerButtons();
});
